/**
 * 获取所有的路由文件
 */

import { handleImportAllFileData, inVite } from '@/utils/api';
let files;
if (inVite()) {
  files = import.meta.glob('./routers/**/*.js', { eager: true });
} else {
  files = require.context('./routers', true, /\.js$/);
}
const filesInfo = handleImportAllFileData(files, true);
export default [...Object.values(filesInfo)];
